
import {
    QADASHBOARDSCREEN_LOAD,
    QADASHBOARDSCREEN_UNLOAD,
    QADASHBOARDSCREEN_SET,
} from '../../../actionDefinitions';

import {
    fetchChannels,
    fetchReasonsForContact,
    fetchCalibratedOnSurveyQuestions,
    fetchUserTeamsStats
} from '../../../api/v3/DataApi';

import {
    fetchAllInteractions,
    //fetchSuggestedAudits,
    fetchCompletedAudits,
    fetchProgressOverTimeStats,
    fetchResponseBreakdown,
    fetchQaSurveyforms,
    fetchQaSurveyFormQuestions,
    fetchAgentCompletedAuditsDetails,
    fetchAgentTeamQaScore,
    fetchAuditsReport,
    _submitQaSurvey,
    _postCoachingSession,
    _deleteAudit
} from '../../../api/v3/QaDashboardApi';

import { timePeriodicityOptions } from '../../../constants';
import {
    SurveyType
} from '../../../generated';
import { isDefined } from '../../../utils';

export function loadQaDashboardManagerScreen(fromDate, toDate) {
    return dispatch => {
        dispatch(loadQaSurveyforms());
        dispatch(loadChannels());
        dispatch(loadReasonsForContact());
        dispatch(loadUserTeamsStats());
        dispatch(loadCalibratedOnSurveyQuestions());
        dispatch(loadAllInteractions(fromDate, toDate));
        dispatch(loadCompletedAudits(fromDate, toDate, -1));
        dispatch(loadProgressOverTimeStats(timePeriodicityOptions[0].id, fromDate, toDate, -1));
        //dispatch(loadResponseBreakdown(SurveyType.Agent, fromDate, toDate));        
    };
}

export function loadQaDashboardAgentScreen() {
    return dispatch => {
        dispatch(loadQaSurveyforms());
        dispatch(loadAgentCompletedAuditsDetails(-1, -1));
        dispatch(loadAgentTeamQaScore(-1, -1));
    };
}

export function loadQaAuditScreen() {
    return dispatch => {
        dispatch(loadQaSurveyforms());
    };
}

export function loadQaCoachScreen(agentId, surveyformId) {
    return dispatch => {
        dispatch(loadAgentCompletedAuditsDetails(agentId, surveyformId));
        dispatch(loadAgentTeamQaScore(agentId, surveyformId));
    };
}

export function loadAgentCompletedAuditsDetails(agentId, surveyformId) {
    return dispatch =>
        fetchAgentCompletedAuditsDetails(agentId, surveyformId)
            .then(payload => dispatch({ type: QADASHBOARDSCREEN_LOAD, payload: { currentAgentCompletedAuditsDetails: payload.result } }))
            .catch(payload => dispatch({ type: QADASHBOARDSCREEN_LOAD, error: true, payload }))
}

export function loadAgentTeamQaScore(agentId, surveyformId) {
    return dispatch =>
        fetchAgentTeamQaScore(agentId, surveyformId)
            .then(payload => dispatch({ type: QADASHBOARDSCREEN_LOAD, payload: { currentAgentTeamQaScore: payload.result } }))
            .catch(payload => dispatch({ type: QADASHBOARDSCREEN_LOAD, error: true, payload }))
}

export function loadQaSurveyforms() {
    return dispatch =>
        fetchQaSurveyforms()
            .then(payload => dispatch({
                type: QADASHBOARDSCREEN_LOAD, payload: {
                    qaSurveyforms: payload.result,
                    selectedQaSurveyform: payload.result ? payload.result[0] : undefined
                }
            }))
            .catch(payload => dispatch({ type: QADASHBOARDSCREEN_LOAD, error: true, payload }))
}

export function loadQaSurveyFormQuestions(surveyformId) {
    return dispatch =>
        fetchQaSurveyFormQuestions(surveyformId)
            .then(payload => dispatch({ type: QADASHBOARDSCREEN_LOAD, payload: { qaSurveyFormQuestions: payload.result } }))
            .catch(payload => dispatch({ type: QADASHBOARDSCREEN_LOAD, error: true, payload }))
}

export function loadAllInteractions(fromDate, toDate) {
    return dispatch =>
        fetchAllInteractions(fromDate, toDate)
            .then(payload => dispatch({
                type: QADASHBOARDSCREEN_LOAD, payload: {
                    allInteractions: payload.result.allInteractions,
                    allInteractionCount: payload.result.allInteractionCount,
                    allAgentCount: payload.result.allAgentCount,
                    suggestedAudits: isDefined(payload.result.allInteractions) ? payload.result.allInteractions.slice(0, 5) : []
                }
            }))
            .catch(payload => dispatch({ type: QADASHBOARDSCREEN_LOAD, error: true, payload }))
}

export function loadCompletedAudits(fromDate, toDate, surveyFormId) {
    return dispatch =>
        fetchCompletedAudits(fromDate, toDate, surveyFormId)
            .then(payload => dispatch({ type: QADASHBOARDSCREEN_LOAD, payload: { completedAudits: payload.result } }))
            .catch(payload => dispatch({ type: QADASHBOARDSCREEN_LOAD, error: true, payload }))
}

export function loadCalibratedOnSurveyQuestions() {
    return dispatch =>
        fetchCalibratedOnSurveyQuestions()
            .then(payload => dispatch({ type: QADASHBOARDSCREEN_LOAD, payload: { calibratedOnSurveyQuestions: payload.result } }))
            .catch(payload => dispatch({ type: QADASHBOARDSCREEN_LOAD, error: true, payload }))
}

export function loadChannels() {
    return dispatch =>
        fetchChannels()
            .then(payload => dispatch({ type: QADASHBOARDSCREEN_LOAD, payload: { channels: payload.result } }))
            .catch(payload => dispatch({ type: QADASHBOARDSCREEN_LOAD, error: true, payload }))
}

export function loadReasonsForContact() {
    return dispatch =>
        fetchReasonsForContact()
            .then(payload => dispatch({ type: QADASHBOARDSCREEN_LOAD, payload: { reasonsForContact: payload.result } }))
            .catch(payload => dispatch({ type: QADASHBOARDSCREEN_LOAD, error: true, payload }))
}

export function loadUserTeamsStats() {
    return dispatch =>
        fetchUserTeamsStats()
            .then(payload => dispatch({ type: QADASHBOARDSCREEN_LOAD, payload: { userTeamsStats: payload.result } }))
            .catch(payload => dispatch({ type: QADASHBOARDSCREEN_LOAD, error: true, payload }))
}

export function loadProgressOverTimeStats(timePeriodicity, fromDate, toDate, surveyFormId, reasonForContactId, channelId) {
    return dispatch =>
        fetchProgressOverTimeStats(timePeriodicity, fromDate, toDate, surveyFormId, reasonForContactId, channelId)
            .then(payload => dispatch({ type: QADASHBOARDSCREEN_LOAD, payload: { progressOverTimeStats: payload.result } }))
            .catch(payload => dispatch({ type: QADASHBOARDSCREEN_LOAD, error: true, payload }))
}

export function loadResponseBreakdown(surveyTypeId, fromDate, toDate) {
    //return dispatch =>
    //    fetchResponseBreakdown(surveyTypeId, fromDate, toDate)
    //        .then(payload => dispatch({ type: QADASHBOARDSCREEN_LOAD, payload: { responseBreakdown: payload.result } }))
    //        .catch(payload => dispatch({ type: QADASHBOARDSCREEN_LOAD, error: true, payload }))
}

export function postCoachingSession(coachingSession) {
    return dispatch =>
        _postCoachingSession(coachingSession)
            .then(payload => dispatch({ type: QADASHBOARDSCREEN_LOAD, payload: { coachingSessionIsDone: payload.result } }))
            .catch(payload => dispatch({ type: QADASHBOARDSCREEN_LOAD, error: true, payload }))
}

export function deleteAudit(surveyId) {
    return dispatch =>
        _deleteAudit(surveyId)
            .then(payload => dispatch({ type: QADASHBOARDSCREEN_LOAD, payload: { deletedAuditSurveyId: payload.result } }))
            .catch(payload => dispatch({ type: QADASHBOARDSCREEN_LOAD, error: true, payload }))
}

export function submitQaSurvey(jibeSession, callBackFunc) {
    return dispatch =>
        _submitQaSurvey(jibeSession)
            .then(payload => dispatch({ type: QADASHBOARDSCREEN_LOAD, payload: { submittedQaSurvey: payload.result } }))
            .then(() => callBackFunc())
            .catch(payload => dispatch({ type: QADASHBOARDSCREEN_LOAD, error: true, payload }))
}

export function loadAuditsReport(surveyFormId, fromDate, toDate) {
    return dispatch =>
        fetchAuditsReport(surveyFormId, fromDate, toDate)
            .then(payload => dispatch({ type: QADASHBOARDSCREEN_SET, payload: { /*auditsReport: payload.result*/ } }))
            .catch(payload => dispatch({ type: QADASHBOARDSCREEN_SET, error: true, payload }))
}

export function updateProps(updatedProps) {
    return dispatch => {
        return dispatch({ type: QADASHBOARDSCREEN_SET, updatedProps });
    }
}

